import React from "react";

interface BounceIconProps {
  className?: string;
}

const BounceIcon: React.FC<BounceIconProps> = ({ className }) => (
  <svg
    className={className}
    id="Capa_1"
    enableBackground="new 0 0 512 512"
    height="512"
    viewBox="0 0 512 512"
    width="512"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g>
      <path
        clipRule="evenodd"
        d="m350.449 213.752c-8.45 4.872-16.61 10.239-24.437 16.074-6.668 4.971-16.103 3.594-21.074-3.074-4.97-6.668-3.594-16.103 3.074-21.074 8.986-6.698 18.365-12.849 28.085-18.415-3.114-9.144-4.804-18.948-4.804-29.146 0-49.901 40.452-90.353 90.353-90.353s90.354 40.453 90.354 90.354-40.452 90.353-90.353 90.353c-28.916 0-54.66-13.584-71.198-34.719zm-335.39 34.719c-8.317 0-15.059-6.743-15.059-15.059 0-8.317 6.742-15.059 15.059-15.059 16.419 0 32.603 1.88 48.325 5.568 8.097 1.899 13.121 10.003 11.222 18.1s-10.003 13.121-18.1 11.222c-13.472-3.161-27.348-4.772-41.447-4.772zm92.912 25.681c-7.13-4.283-9.437-13.534-5.154-20.664 4.283-7.129 13.534-9.437 20.664-5.154 13.942 8.375 26.876 18.341 38.537 29.68 5.963 5.798 6.097 15.331.299 21.294s-15.332 6.096-21.295.299c-10.005-9.726-21.097-18.274-33.051-25.455zm66.507 69.854c-3.926-7.332-1.165-16.458 6.167-20.384s16.458-1.165 20.384 6.167c7.671 14.325 13.665 29.509 17.842 45.283 2.129 8.04-2.662 16.283-10.702 18.412s-16.283-2.663-18.412-10.702c-3.576-13.506-8.709-26.506-15.279-38.776zm87.156-94.733c5.374-6.347 14.875-7.137 21.223-1.764 6.347 5.374 7.137 14.875 1.764 21.223-9.193 10.859-17.443 22.485-24.649 34.748-4.214 7.17-13.442 9.567-20.613 5.353s-9.567-13.442-5.353-20.613c8.079-13.746 17.325-26.777 27.628-38.947zm-178.81 194.962c-4.159 0-7.529-3.371-7.529-7.529v-15.059c0-4.159 3.371-7.529 7.529-7.529h256c4.159 0 7.529 3.371 7.529 7.529v15.059c0 4.159-3.371 7.529-7.529 7.529z"
        fillRule="evenodd"
      />
    </g>
  </svg>
);

export default BounceIcon;
